export default "__VITE_ASSET__bc78915a__"